import {
  FormControl,
  FormHelperText,
  MenuItem,
  Select,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import SearchIcon from "@mui/icons-material/Search";
import BaseInput from "components/shared/baseForm/BaseInput";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { REQUIRED_ERROR } from "utils/errorMessages";

export default function MarketplaceGuestOrder({ residents }) {
  const { control, formState: { errors } } = useFormContext();

  return (
    <Grid container width="100%" spacing={2} mt={2} justifyContent="center">
      <Grid size={{ xs: 5 }}>
        <BaseInput
          id="guestName"
          control={control}
          errors={errors}
          name="guestName"
          type="text"
          placeholder="Enter Guest Name"
          validationProps={{
            required: REQUIRED_ERROR("Name"),
            maxLength: { value: 50, message: "Guest Name cannot be over 50 characters" },
          }}
          fullWidth
          variant="outlined"
          sx={{ "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
        />
      </Grid>
      <Grid size={{ xs: 5 }} alignSelf="flex-start">
        <Controller
          name="guestOfResidentId"
          control={control}
          defaultValue={0}
          rules={{ validate: (v) => v !== 0 || "Please select a resident" }}
          render={({ field, fieldState: { error } }) => (
            <FormControl fullWidth error={!!error}>
              <Select
                {...field}
                variant="outlined"
                fullWidth
                displayEmpty
                startAdornment={<SearchIcon sx={{ color: "gray !important", fontSize: "24px !important" }} />}
                sx={{ borderRadius: "8px", "& .MuiSelect-select": { paddingLeft: "4px" } }}
              >
                <MenuItem value={0} disabled>Guest Of</MenuItem>
                {residents?.map((res) => (
                  <MenuItem key={res.id} value={res.id}>
                    {res.name?.split("(")?.[0]?.trim()}
                  </MenuItem>
                ))}
              </Select>
              {error && <FormHelperText>{error.message}</FormHelperText>}
            </FormControl>
          )}
        />
      </Grid>
    </Grid>
  );
}
